<template>
  <div class="PopUp" @click="close">
    <div class="img-wrap">
      <div class="img-content">
        <img :src="link" @click="stop" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PopUp",
  props: {
    link: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  methods: {
    stop(e) {
      e.stopPropagation();
    },
    close() {
      this.$emit("close");
    },
  },
  created() {},
};
</script>

<style lang="less">
.PopUp {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;

  .img-wrap {
    overflow-y: scroll;
    width: 100%;
    height: 100%;

    .img-content {
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 100%;
    }

    img {
      max-width: 90%;
    }
  }
}
</style>
